import styled from 'styled-components'

export const Container = styled.section`
    padding: 1.5rem 0;
`
